import React from "react";

import { SearchIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { Tooltip } from "ds/Tooltip";
import { selectCommandMenuEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useCommandMenuContext } from "src/root/pages/components/CommandMenu/hooks";
import { useAppSelector } from "Store/hooks";

import * as S from "./styles";

const CommandKTiggerer = () => {
  const { isCommandMenuOpen, setIsCommandMenuOpen } = useCommandMenuContext();
  const isCommandMenuEnabled = useAppSelector(selectCommandMenuEnabled);
  const intl = useIntl();

  if (!isCommandMenuEnabled) return;

  return (
    <S.Container
      role="button"
      aria-expanded={isCommandMenuOpen}
      aria-label="button-cmd"
      onClick={event => {
        event.preventDefault();
        setIsCommandMenuOpen(!isCommandMenuOpen);
      }}
    >
      <Tooltip
        tooltip={intl.formatMessage({ id: "command_k.triggerer.tooltip" })}
      >
        <SearchIcon color="var(--mode-overrides-header-text)" />
      </Tooltip>
    </S.Container>
  );
};

export default CommandKTiggerer;
